// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://cwnmcwzjggcpwhcnmjub.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN3bm1jd3pqZ2djcHdoY25tanViIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzYyMzU0NzEsImV4cCI6MjA1MTgxMTQ3MX0.dMUJEmZUyD_Z6rBeeVIpoBq9B1GHZkrJSjV6Dppq8xA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);